import {CKEditor} from "@ckeditor/ckeditor5-react";
import {BalloonEditor, Bold, Essentials, Italic, Paragraph, Strikethrough, Underline} from "ckeditor5";
import {useEffect, useMemo, useRef, useState} from "react";
import translations from 'ckeditor5/translations/ko.js';
import 'ckeditor5/ckeditor5.css';

const CKEditorInlineBubbleComponent = ({content, setContent}) => {
    const editorContainerRef = useRef(null);
    const editorRef = useRef(null);
    const [isLayoutReady, setIsLayoutReady] = useState(false);

    useEffect(() => {
        setIsLayoutReady(true);

        return () => setIsLayoutReady(false);
    }, []);

    const { editorConfig } = useMemo(() => {
        if (!isLayoutReady) {
            return {};
        }

        return {
            editorConfig: {
                toolbar: {
                    items: ['bold', 'italic', 'underline', 'strikethrough'],
                    shouldNotGroupWhenFull: false
                },
                plugins: [ Bold, Essentials, Italic,  Paragraph, Underline],
                language: 'ko',
                placeholder:'내용을 입력하세요',
                licenseKey: 'GPL',
                translations:[translations],
            }
        };
    }, [isLayoutReady]);

    return (
        <div className="w-full">
            <div className="" ref={editorContainerRef}>
                <div ref={editorRef}>{editorConfig &&
                    <CKEditor
                        editor={BalloonEditor}
                        data={content}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setContent(data);
                        }}
                        config={editorConfig}
                    />
                }
                </div>
            </div>
        </div>
    );
}

export default CKEditorInlineBubbleComponent;